import { render, staticRenderFns } from "./PrintModuleMarksDialog.vue?vue&type=template&id=16456a5f"
import script from "./PrintModuleMarksDialog.vue?vue&type=script&lang=js"
export * from "./PrintModuleMarksDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports